import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import MakeUserView from '../views/MakeUserView.vue';
import TermsView from '../views/TermsView.vue';
import ItemListView from '../views/ItemListView.vue';
import FAQView from '../views/FAQView.vue';
import EditCategory from '../components/EditCategory.vue';
import ShareURL from '../components/ShareURL.vue';
import store from '../store';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '食材管理くん', description: 'フードロス削減のための管理ツール『食材管理君』で、家庭や職場での食品廃棄を減らしましょう！TODO型のリスト機能を使って食品の管理を簡単に行え、無駄をなくす手助けをします。' }
  },
  {
    path: '/editcategory',
    name: 'editcategory',
    component: EditCategory,
    meta: { title: 'カテゴリー編集', description: 'カテゴリー編集' }
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView,
    meta: { title: '利用規約・プライバシーポリシー', description: '利用規約・プライバシーポリシー' }
  },
  {
    path: '/makeuser',
    name: 'makeuser',
    component: MakeUserView,
    meta: { title: 'カテゴリの初期設定を行います', description: 'カテゴリの初期設定' }
  },
  {
    path: '/itemlist',
    name: 'itemlist',
    component: ItemListView,
    meta: { title: 'アイテム一覧', description: 'アイテム一覧' }
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQView,
    meta: { title: 'よくある質問', description: 'よくある質問' }
  },
  {
    path:'/shareurl',
    name: 'shareurl',
    component: ShareURL,
    meta: { title: 'URLをシェアする', description: 'URLをシェアする' }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// beforeEach でクエリパラメータを確認し、user_idをストアに保存
router.beforeEach((to, from, next) => {
  const user_id = to.query.user_id;

  if (user_id) {
    // ストアにuser_idを保存する
    store.commit("set_user_info", user_id);
  }

  next();
});

router.afterEach((to, from) => {
  document.title = to.meta.title || 'デフォルトタイトル';
  document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description || 'デフォルトの説明');
  console.log(to, from);
});

export default router;
